import React, { useRef, useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here
import withPasteUpload from "@rpldy/upload-paste";
import Uploady from "@rpldy/uploady";

const viewImg = require("./../assets/img/viewImg.png");
const backBtn = require("./../assets/img/back-btn.svg").default;
const CrossBtn = require("./../assets/img/cross-icon.svg").default;
const logo = require("./../assets/img/logo.svg").default;
const demoImg = require("./../assets/img/demo-img.png");
const companyLogo = require("./../assets/img/company-logo.svg").default;
const passwordIcon = require("./../assets/img/password-icon.svg").default;

const EditUser = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [selectedImages, setSelectedImages] = useState([]);

  const [userData, setUserData] = useState(null);

  const [selectedCheckboxes, setSelectedCheckboxes] = useState({});
  const [customerDefault, setCustomerDefault] = useState("");
  const [errorMsg, setErrorMsg] = useState();
  const [draggingOver, setDraggingOver] = useState(false);
  const [dragEnabled, setDragEnabled] = useState(true);
  const [formError, setFormError] = useState("");
  const [loading, setLoading] = useState(false);
  const [avatarImage, setAvatarImage] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    avatar: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleImageChange = (event) => {
    // const files = event.target.files;
    // const fileArray = Array.from(files);
    // setSelectedImages((prevSelectedImages) => [
    //   ...prevSelectedImages,
    //   ...fileArray,
    // ]);

    event.preventDefault();
    const files = event.target.files;
    const newImages = [...selectedImages];
    setAvatarImage(null);
    for (let i = 0; i < files.length; i++) {
      if (files[i] && isImageFile(files[i])) {
        console.log("normal file:", files[i]);
        newImages.push(files[i]);
        // You can now upload or process the pasted file
        setErrorMsg(null);
      } else {
        setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
        setTimeout(() => {
          setErrorMsg(null);
        }, 2000);
      }
    }
    setSelectedImages(newImages);
    console.log("newImages: ", newImages);
    event.target.value = null;
  };

  const handleRemoveImage = (index) => {
    const updatedImages = [...selectedImages];
    updatedImages.splice(index, 1);
    setSelectedImages(updatedImages);
  };

  // Edit user function
  const formSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    let finalFormDataCopy = { ...formData };
    if (selectedImages[0]) {
      finalFormDataCopy.avatar = selectedImages[0];
    } else {
      finalFormDataCopy.avatar = "";
    }
    const fd = new FormData();
    // Object.keys(finalFormDataCopy).map(item => fd.append(item, finalFormDataCopy[item]));
    fd.append("name", finalFormDataCopy.name);
    fd.append("email", finalFormDataCopy.email);
    fd.append("password", finalFormDataCopy.password);
    // fd.append("avatar", finalFormDataCopy.avatar);
    if (!finalFormDataCopy.name) {
      setFormError("Name is required.");
      setLoading(false);
      return;
    } else if (!finalFormDataCopy.email) {
      setFormError("Email is required.");
      setLoading(false);
      return;
    } else if (
      !/^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$/.test(finalFormDataCopy.email)
    ) {
      setFormError("Email is not valid. Please enter valid email.");
      setLoading(false);
      return;
    } else if (!finalFormDataCopy.password) {
      setFormError("Password is required.");
      setLoading(false);
      return;
      // } else if (!finalFormDataCopy.avatar) {
      //   setFormError("Please select a avatar image.");
      //   setLoading(false);
    } else {
      setFormError("");
      console.log(finalFormDataCopy);
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      fetch(`https://cliqestimatebuilder.com/waiver_admin/users/${userId}`, {
        headers: {
          Authorization: `Bearer ${storedUserData.token}`,
        },
        method: "PUT",
        body: fd,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.res == 1) {
            // setFormData({name: null, email: null, avatar: null});
            // navigate("/users");
            setFormError(data.msg);
          } else {
            setFormError(data.msg);
          }
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching file data:", error);
          setLoading(false);
        });
    }
  };

  const isImageFile = (file) => {
    // Define accepted image MIME types
    const acceptedImageTypes = ["image/jpeg", "image/png"];

    // Check if the file's MIME type is in the accepted types array
    return acceptedImageTypes.includes(file.type);
  };

  const PasteArea = withPasteUpload(({ onPasteUpload }) => {
    return (
      <div
        style={{
          width: "400px",
          height: "400px",
          border: "2px dashed #000", // Add a dashed border for visualization
          display: "none",
          alignItems: "center",
          justifyContent: "center",
        }}
        onPaste={onPasteUpload}
      >
        Paste file here to upload
      </div>
    );
  });

  const onPasteUpload = useCallback((event) => {
    event.preventDefault(); // Prevent the default paste behavior
    const clipboardData = event.clipboardData || window.clipboardData;
    setAvatarImage(null);
    // const newImages = [];
    if (clipboardData && clipboardData.items) {
      const item = clipboardData.items[0];
      if (item.kind === "file") {
        const file = item.getAsFile();
        if (file && isImageFile(file)) {
          setSelectedImages([file]);
        } else {
          setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
          setTimeout(() => {
            setErrorMsg(null);
          }, 2000);
        }
      }
    }
    event.target.value = null;
  }, []);

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files[0];
    setAvatarImage(null);
    if (files && isImageFile(files)) {
      // You can now upload or process the pasted file
      setSelectedImages([files]);
      setErrorMsg(null);
    } else {
      setErrorMsg("Upload valid images. Only PNG and JPEG are allowed.");
      setTimeout(() => {
        setErrorMsg(null);
      }, 2000);
    }
    setDraggingOver(false);
    setDragEnabled(false);
    e.target.value = null;
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDraggingOver(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDraggingOver(true);
  };

  const handleDragLeave = () => {
    setDraggingOver(false);
  };

  const fetchUserDetails = () => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    fetch(`https://cliqestimatebuilder.com/waiver_admin/users/${userId}`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.res == 1) {
          setFormData({
            name: data.data.name,
            email: data.data.email,
            password: data.data.password,
            avatar: data.data.avatar,
          });
          setAvatarImage(data.data.avatar);
        } else {
          setFormError(data.msg);
        }
      })
      .catch((error) => console.error("Error fetching file data:", error));
  };

  // useEffect(() => {
  //   const acceptableTag = document.querySelector(".imgBox");
  //   acceptableTag.addEventListener("paste", onPasteUpload);

  //   return () => {
  //     // Remove the paste event listener when the component unmounts
  //     acceptableTag.removeEventListener("paste", onPasteUpload);
  //   };
  // }, [onPasteUpload]);

  useEffect(() => {
    fetchUserDetails();
    return () => {
      setFormData({ name: null, email: null, avatar: null });
      setFormError("");
    };
  }, []);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <form onSubmit={formSubmit}>
            <div className="viewOne">
              <div className="viewOneLeft">
                <h2>Edit User</h2>
              </div>
              <div className="viewOneRight"></div>
            </div>

            <div className="viewBox ">
              <ul className="previewOne crteForm udtUl">
                <li>
                  <div className="inCkeck">
                    <>
                      <label>Name:</label>
                    </>
                  </div>
                  <span>
                    <input
                      name="name"
                      type="text"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </span>
                </li>
                <li>
                  <div className="inCkeck">
                    <>
                      <label>Email:</label>
                    </>
                  </div>
                  <span>
                    <input
                      name="email"
                      type="text"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </span>
                </li>
                <li>
                  <div className="inCkeck">
                    <>
                      <label>Passowrd:</label>
                    </>
                  </div>
                  <span>
                    <input
                      name="password"
                      type={showPassword ? "text" : "password"}
                      value={formData.password}
                      onChange={handleChange}
                    />
                  </span>
                  <div
                    className="visibleClick edtUsr"
                    onClick={togglePasswordVisibility}
                  >
                    <img src={passwordIcon} alt="Toggle Password Visibility" />
                  </div>
                </li>
                {/* <li>
                  <div className="inCkeck">
                    <label>Avatar:</label>
                  </div>
                  <div className="imgBox" onDrop={handleDrop} onDragOver={handleDragOver} onDragEnter={handleDragEnter} onDragLeave={handleDragLeave}>
                    {avatarImage ? (
                      <div className="image-preview">
                        <div className="image-container">
                          <img src={`https://cliqestimatebuilder.com/waiver_admin/${avatarImage}`} className="upImg" />
                          <button
                            className="remove-btn"
                            onClick={() => {
                              setAvatarImage(null);
                              setFormData({...formData, avatar: null});
                            }}>
                            <img src={CrossBtn} alt="Remove" />
                          </button>
                        </div>
                      </div>
                    ) : null}

                    {selectedImages.length > 0 && (
                      <div className="image-preview">
                        {selectedImages.map((image, index) => (
                          <div key={index} className="image-container">
                            <img src={URL.createObjectURL(image)} alt={`Uploaded ${index + 1}`} className="upImg" />
                            <button className="remove-btn" onClick={() => handleRemoveImage(index)}>
                              <img src={CrossBtn} alt="Remove" />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                    <div className="upload-btn-wrapper">
                      <input type="file" accept="image/*" onChange={handleImageChange} />
                    </div>
                    <Uploady>
                      <PasteArea />
                    </Uploady>
                  </div>
                  {errorMsg ? <span className="msgBrse errMsgClr">{errorMsg}</span> : null}

                  <p className="msgBrse">*Browse image or Drag and drop image here</p>
                </li> */}
                <li>
                  {loading ? (
                    <button type="submit" disabled className="userFormBtn">
                      Please wait...
                    </button>
                  ) : (
                    <button type="submit" className="userFormBtn">
                      Update User
                    </button>
                  )}
                </li>
                <li>
                  {formError ? (
                    <span className="lgnStatus">{formError}</span>
                  ) : null}
                </li>
              </ul>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditUser;
